<template>
  <v-layout row wrap>
    <v-flex pl-2 xs12>
      <h3>Driver Document Reminders</h3>
    </v-flex>
    <v-layout pt-2 class="search-fields" column v-on:keyup.enter="search">
      <v-select
        v-model="query.filter"
        :value="query.filter"
        :items="items"
        item-text="name"
        item-value="value"
        label="Filter By"
      ></v-select>
      <v-layout>
        <v-checkbox
            v-model="query.lockedOut"
            label="Show Locked Out Drivers"
        />
      </v-layout>
      <v-flex pt-3 style="flex: 1">
        <v-btn @click="search" color="blue" dark class="text-none"
          >Search</v-btn
        >
      </v-flex>
      <v-flex pt-3 style="flex: 1">
        <v-btn
          @click="checkForExpiredDocuments"
          color="blue"
          dark
          class="text-none"
          >Check for Expired<br />Documents</v-btn
        ></v-flex
      >
    </v-layout>
  </v-layout>
</template>

<script>
import qs from "qs";
import axios from "axios";
axios.defaults.withCredentials = true;

export default {
  name: "driver_photos_search_box",
  props: {
    query: Object,
  },
  data: function () {
    return {
      rideTypes: null,
      items: [
        { name: "Pending Upload", value: "missing" },
        { name: "Requires Verification", value: "pending" },
        { name: "Completed", value: "completed" },
        { name: "Rejected", value: "rejected" },
        { name: "Expiring", value: "expiring" },
        { name: "All", value: "all" },
      ],
    };
  },
  mounted: async function () {},
  methods: {
    fromChanged: function (d) {
      this.query.after = d;
    },
    toChanged: function (d) {
      this.query.before = d;
    },
    search: function () {
      this.$emit("search");
    },
    clear: function () {
      this.$emit("clear");
    },
    checkForExpiredDocuments: function () {
      this.$emit("checkForExpiredDocuments");
    },
  },
  components: {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.search-fields {
  padding-left: 6px;
  padding-right: 6px;
}

.small-label .v-label {
  font-size: 14px !important;
}
</style>
